<!--
  Material 21's <mat-optgroup> changed the projection model: the default <ng-content>
  now lives inside an .mdc-list-item__primary-text span that has overflow:hidden and
  role="presentation", which clipped the search field and broke click/keyboard input.
  A plain sticky <div> sits at the top of the panel the same way visually (the
  sticky positioning was always done by .sg-select-autocomplete-optgroup, not by
  mat-optgroup itself) without forcing the content through the optgroup label span.
-->
<div class="sg-select-autocomplete-optgroup">
  <mat-form-field floatLabel="auto" subscriptSizing="dynamic">
    <input matInput autocomplete="off" (input)="_onInput($any($event).target.value)" (keydown)="$event.stopPropagation()" [placeholder]="placeholder" />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
</div>
